import {
  FaGraduationCap,
  FaRegEnvelope,
  FaCalendarAlt,
  FaUserGraduate,
  FaClipboardList,
  FaFileAlt,
  FaBook,
  FaChartBar,
  FaBullhorn,
  FaSms,
  FaCalendarCheck,
  FaTable,
} from "react-icons/fa";
import {
  MdDashboard,
  MdEvent,
  MdMenuBook,
  MdMessage,
  // MdScool,
} from "react-icons/md";
import { LuBrain } from "react-icons/lu";
// import { PiBrainFill } from "react-icons/pi";
import { BsFillGridFill } from "react-icons/bs";
import EventNoteIcon from "@mui/icons-material/EventNote";
import AssignmentIcon from "@mui/icons-material/Assignment";
import PaymentsIcon from "@mui/icons-material/Payments";
import SettingsIcon from "@mui/icons-material/Settings";
// import AssignmentReturnedIcon from "@mui/icons-material/AssignmentReturned";
import CastConnectedIcon from "@mui/icons-material/CastConnected";
import { ALL_PLANS, AI_ONLY, filterMenuItems } from "../../utils/access";

// Access rules per menu node (evaluated in src/utils/access.js):
//   feature_type -> allowed values of user.plan_details[0].feature_type.
//                   REQUIRED on every node; a node without it stays hidden.
//   addon: true  -> the node's id/title must match an entry in user.add_ons
//                   (addon_key / addon_name, case-insensitive).
//   addon: "key" -> match that explicit addon key instead.
//   is_org: true -> only for organisation plans (plan_details[0].is_org === 1).
export const menuConfig = {
  group_cockpit: [
    {
      id: "dashboard",
      title: "Dashboard",
      path: "/user/dashboard",
      icon: BsFillGridFill,
      feature_type: ALL_PLANS,
    },
    {
      id: "admission",
      title: "Admission",
      path: "/user/admission",
      icon: FaGraduationCap,
      feature_type: ALL_PLANS,
      children: [
        {
          id: "admissionConfig",
          title: "Admission Config",
          path: "/user/admission/applications",
          icon: FaClipboardList,
          feature_type: ALL_PLANS,
        },
      ],
    },
    {
      id: "messaging",
      title: "Messaging",
      path: "/user/messaging",
      icon: FaRegEnvelope,
      feature_type: ALL_PLANS,
      children: [
        {
          id: "messaging-sms",
          title: "Create Message",
          path: "/user/messaging/create",
          icon: FaSms,
          feature_type: ALL_PLANS,
        },
        {
          id: "messaging-email",
          title: "Manage Message",
          path: "/user/messaging/email",
          icon: FaRegEnvelope,
          feature_type: ALL_PLANS,
        },
      ],
    },
    {
      id: "events",
      title: "Events",
      path: "/user/events",
      icon: FaCalendarAlt,
      feature_type: ALL_PLANS,
      children: [
        {
          id: "eventCalendar",
          title: "Event Calendar",
          path: "/user/calenderList",
          icon: FaCalendarCheck,
          feature_type: ALL_PLANS,
        },
        // {
        //   id: "events-create",
        //   title: "Create Event",
        //   path: "/user/events/create",
        //   icon: FaCalendarPlus,
        // },
        // {
        //   id: "events-manage",
        //   title: "Manage Events",
        //   path: "/user/events/manage",
        //   icon: FaTasks,
        // },
      ],
    },
  ],

  school_cockpit: [
    {
      id: "dashboard",
      title: "Dashboard",
      path: "/user/students",
      icon: BsFillGridFill,
      feature_type: ALL_PLANS,
      children: [
        {
          id: "campusHub",
          title: "Campus Hub ",
          path: "/user/dashboard",
          icon: AssignmentIcon,
          feature_type: ALL_PLANS,
        },
        {
          id: "aiDashboard",
          title: "AI Analytics",
          path: "/user/ai-dashboard",
          icon: FaChartBar,
          feature_type: AI_ONLY,
        },
        {
          id: "attendanceDashboard",
          title: "Attendance ",
          path: "/user/Student-Attendance-Dashboard",
          icon: CastConnectedIcon,
          feature_type: ALL_PLANS,
        },
      ],
    },
    {
      id: "admission",
      title: "Admission",
      path: "/user/admission",
      icon: FaGraduationCap,
      feature_type: ALL_PLANS,
      children: [
        {
          id: "admissionCycleConfig",
          title: "Admission Cycle Config",
          path: "/user/Admission-Cycle-Config",
          feature_type: ALL_PLANS,
        },
        {
          id: "admissionSeatAllocationConfig",
          title: "Admission Seat Allocation Config",
          path: "/user/Admission-Seat-Allocation-Config",
          feature_type: ALL_PLANS,
        },
        {
          id: "admissionApplicationList",
          title: "Admission Application List",
          path: "/user/Admission-List",
          feature_type: ALL_PLANS,
        },
        {
          id: "annualAcademicTransition",
          title: "Annual Academic Transition",
          path: "/user/Academic-Transition",
          feature_type: ALL_PLANS,
        },
        //   {
        //   id: "AdmissionSchedule",
        //   title: "Admission Schedule",
        //   path: "/user/admission-schedule",
        // },
      ],
    },
    {
      id: "report",
      title: "Report",
      path: "/user/report",
      icon: FaChartBar,
      feature_type: ALL_PLANS,
      children: [
        // {
        //   id: "studentReport",
        //   title: "Student Report",
        //   path: "/user/studentReport",
        // },
        {
          id: "attendanceReport",
          title: "Attendance Report",
          path: "/user/StudentAttendanceReportGenerate",
          feature_type: ALL_PLANS,
        },
      ],
    },
    {
      id: "time-table",
      title: "Time-Table",
      path: "/user/admission",
      icon: FaTable,
      feature_type: ALL_PLANS,
      children: [
        {
          id: "shift",
          title: "Shift",
          path: "/user/timetable",
          feature_type: ALL_PLANS,
        },
        {
          id: "dayScheduleList",
          title: "Day Schedule List",
          path: "/user/timeList",
          feature_type: ALL_PLANS,
        },
        {
          id: "timeTableView",
          title: "Time-Table",
          path: "/user/createtimetbListView",
          feature_type: ALL_PLANS,
        },
      ],
    },
    {
      id: "messaging",
      title: "Messaging",
      path: "/user/messaging",
      icon: FaRegEnvelope,
      feature_type: ALL_PLANS,
      children: [
        {
          id: "messagingSms",
          title: "Create Message",
          path: "/user/messaging/create",
          // icon: FaSms,
          feature_type: ALL_PLANS,
        },
        {
          id: "messagingEmail",
          title: "Manage Message",
          path: "/user/messaging/email",
          // icon: FaRegEnvelope,
          feature_type: ALL_PLANS,
        },
      ],
    },
    {
      id: "events",
      title: "Events",
      path: "/user/events",
      icon: EventNoteIcon,
      feature_type: ALL_PLANS,
      children: [
        {
          id: "createEvent",
          title: "Create New",
          path: "/user/calender/create",
          feature_type: ALL_PLANS,
        },
        {
          id: "eventCalendar",
          title: "Event Calender",
          path: "/user/calenderList",
          feature_type: ALL_PLANS,
        },
      ],
    },
    {
      id: "master",
      title: "Master",
      path: "/user/students",
      icon: FaChartBar,
      feature_type: ALL_PLANS,
      children: [
        {
          id: "academicConfiguration",
          title: "Academic Configuration",
          path: "/user/academicList",
          feature_type: ALL_PLANS,
        },
        {
          id: "Subject",
          title: "Subject",
          path: "/user/ListSubject",
          feature_type: ALL_PLANS,
        },
        {
          id: "Group",
          title: "Group",
          path: "/user/GroupList",
          feature_type: ALL_PLANS,
        },

        {
          id: "staff",
          title: "Staff",
          path: "/user/staffList",
          feature_type: ALL_PLANS,
        },
        {
          id: "class",
          title: "Class",
          path: "/user/classList",
          feature_type: ALL_PLANS,
        },
        {
          id: "student",
          title: "Student",
          path: "/user/student",
          feature_type: ALL_PLANS,
        },
        {
          id: "holiday",
          title: "Holiday",
          path: "/user/holidayList",
          feature_type: ALL_PLANS,
        },
        {
          id: "bulkUpload",
          title: "Bulk Upload",
          path: "/user/upload",
          feature_type: ALL_PLANS,
        },
        {
          id: "syllabus",
          title: "Syllabus",
          path: "/user/SchoolClassList",
          feature_type: ALL_PLANS,
        },
        {
          id: "book",
          title: "Book",
          path: "/user/bookList",
          feature_type: ALL_PLANS,
        },
        // {
        //   id: "receiver",
        //   title: "Receiver",
        //   path: "/user/receiver",
        // },
        // {
        //   id: "botAttendance",
        //   title: "BOT Attendance",
        //   path: "/user/iotlist",
        // },
      ],
    },
    {
      id: "exam",
      title: "Exam",
      path: "/user/students",
      icon: AssignmentIcon,
      feature_type: ALL_PLANS,
      children: [
        {
          id: "examConfiguration",
          title: "Exam Configuration",
          path: "/user/examList",
          feature_type: ALL_PLANS,
        },
        {
          id: "examRules",
          title: "Exam Rules",
          path: "/user/examRulesList",
          feature_type: ALL_PLANS,
        },
        {
          id: "examSchedule",
          title: "Exam Schedule",
          path: "/user/examSchedule",
          feature_type: ALL_PLANS,
        },
        {
          id: "examTimeTable",
          title: "Exam Time Table",
          path: "/user/examTimeTable",
          feature_type: ALL_PLANS,
        },
        {
          id: "examResult",
          title: "Exam Result",
          path: "/user/examResult",
          feature_type: ALL_PLANS,
        },
      ],
    },
    // {
    //   id: "download",
    //   title: "Download",
    //   path: "/user/academics",
    //   icon: AssignmentReturnedIcon,
    //   children: [
    //     {
    //       id: "applicationDetails",
    //       title: "Application Details",
    //       path: "/user/applicationlist",
    //     },
    //   ],
    // },
    {
      id: "aiAssistant",
      title: "AI Assistant",
      path: "/user/lessonPlanApproval",
      icon: FaTable,
      feature_type: AI_ONLY,
      children: [
        {
          id: "lessonPlanApprove",
          title: "Lesson Plan Approval",
          path: "/user/lessonPlanApproval",
          feature_type: AI_ONLY,
        },
      ],
    },
    {
      id: "fees",
      title: "Fees",
      path: "/user/listFeeDiscount",
      icon: PaymentsIcon,
      feature_type: ALL_PLANS,
      addon: true,
      children: [
        {
          id: "feeType",
          title: "Fees Type",
          path: "/user/listFeeType",
          feature_type: ALL_PLANS,
        },
        {
          id: "feeDiscount",
          title: "Fee Discount",
          path: "/user/listFeeDiscount",
          feature_type: ALL_PLANS,
        },
        {
          id: "groupFee",
          title: "Group Fees",
          path: "/user/listGroupFee",
          feature_type: ALL_PLANS,
        },
        {
          id: "feeAssign",
          title: " Assign Fees",
          path: "/user/listAssignFees",
          feature_type: ALL_PLANS,
        },
        {
          id: "collectFees",
          title: " Collect Fees",
          path: "/user/listCollectFees",
          feature_type: ALL_PLANS,
        },
        {
          id: "paymentApproval",
          title: " Payment Approval",
          path: "/user/listPaymentApproval",
          feature_type: ALL_PLANS,
        },
        {
          id: "feeDashboard",
          title: " Fees Dashboard",
          path: "/user/feeDashboard",
          feature_type: ALL_PLANS,
        },
        {
          id: "dueFeeReport",
          title: "Due Fee Report",
          path: "/user/dueFeeReport",
          feature_type: ALL_PLANS,
        },
        {
          id: "discountReport",
          title: "Discount Report",
          path: "/user/discountReport",
          feature_type: ALL_PLANS,
        },
        {
          id: "feesTransactionsReport",
          title: "Fees Transactions Report",
          path: "/user/feesTransactionsReport",
          feature_type: ALL_PLANS,
        },
      ],
    },
    {
      id: "settings",
      title: "Settings",
      path: "/user/settings",
      icon: SettingsIcon,
      feature_type: ALL_PLANS,
      is_org: true,
      children: [
        {
          id: "settings",
          title: "Settings",
          path: "/user/settings",
          feature_type: ALL_PLANS,
        },
        {
          id: "school-details",
          title: "School Details",
          path: "/user/school-setup",
          feature_type: ALL_PLANS,
        },
      ],
    },
    // {
    //   id: "aiDashboard",
    //   title: "AI Dashboard",
    //   path: "/user/ai-dashboard",
    //   icon: FaChartBar,
    // },
  ],

  staff: [
    {
      id: "dashboard",
      title: "Dashboard",
      path: "/user/students",
      icon: BsFillGridFill,
      feature_type: ALL_PLANS,
      children: [
        {
          id: "campusHub",
          title: "Campus Hub ",
          path: "/user/dashboard",
          icon: MdDashboard,
          feature_type: ALL_PLANS,
        },
        {
          id: "aiDashboard",
          title: "AI Analytics",
          path: "/user/ai-dashboard",
          icon: FaChartBar,
          feature_type: AI_ONLY,
        },
      ],
    },
    {
      id: "leave",
      title: "Leave",
      path: "/user/leave",
      icon: FaCalendarAlt,
      feature_type: ALL_PLANS,
    },
    {
      id: "attendance",
      title: "Attendance",
      icon: FaClipboardList,
      path: "/user/attendance",
      feature_type: ALL_PLANS,
      children: [
        {
          id: "manage-attendance",
          title: "Manage Attendance",
          path: "/user/attendanceList",
          icon: FaClipboardList,
          feature_type: ALL_PLANS,
        },
        {
          id: "monthly-attendance-report",
          title: "Monthly Attendance Report",
          path: "/user/monthlyAttendanceReport",
          icon: FaFileAlt,
          feature_type: ALL_PLANS,
        },
      ],
    },
    {
      id: "messaging",
      title: "Messaging",
      path: "/user/Messaging",
      icon: MdMessage,
      feature_type: ALL_PLANS,
      children: [
        {
          id: "create-message",
          title: "Create Message",
          path: "/user/messaging/create",
          icon: FaBullhorn,
          feature_type: ALL_PLANS,
        },
        {
          id: "manage-messages",
          title: "Manage Messages",
          path: "/user/messaging/email",
          icon: MdMessage,
          feature_type: ALL_PLANS,
        },
      ],
    },
    {
      id: "event",
      title: "Event",
      path: "/user/Event",
      icon: MdEvent,
      feature_type: ALL_PLANS,
      children: [
        {
          id: "event-calendar",
          title: "Event Calendar",
          path: "/user/events",
          icon: MdEvent,
          feature_type: ALL_PLANS,
        },
      ],
    },
    {
      id: "master",
      title: "Master",
      path: "/user/master",
      icon: FaBook,
      feature_type: ALL_PLANS,
      children: [
        {
          id: "students",
          title: "Student",
          path: "/user/student",
          icon: FaUserGraduate,
          feature_type: ALL_PLANS,
        },
        {
          id: "holiday",
          title: "Holiday",
          path: "/user/holidayList",
          icon: FaCalendarAlt,
          feature_type: ALL_PLANS,
        },
        {
          id: "syllabus",
          title: "Syllabus",
          path: "/user/syllabus",
          icon: FaBook,
          feature_type: ALL_PLANS,
        },
        {
          id: "syllabus_submission",
          title: "Syllabus Submission",
          path: "/user/syllabuSubmissionList",
          icon: FaBook,
          feature_type: ALL_PLANS,
        },
      ],
    },
    {
      id: "exam",
      title: "Exam",
      path: "/staff/exam",
      icon: FaFileAlt,
      feature_type: ALL_PLANS,
      children: [
        {
          id: "exam-timetable",
          title: "Exam Time Table",
          path: "/user/examTimeTable",
          icon: FaTable,
          feature_type: ALL_PLANS,
        },
        {
          id: "exam-marks-entry",
          title: "Exam Mark Entry",
          path: "/user/exams/marks",
          icon: FaClipboardList,
          feature_type: ALL_PLANS,
        },
        {
          id: "exam-results",
          title: "Exam Result",
          path: "/user/exams/results",
          icon: FaFileAlt,
          feature_type: ALL_PLANS,
        },
        {
          id: "publish-marks",
          title: "Publish Marks",
          path: "/user/publish",
          icon: FaBullhorn,
          feature_type: ALL_PLANS,
        },
      ],
    },
    {
      id: "timetable",
      title: "Time Table",
      path: "/user/my-classes/schedule",
      icon: FaTable,
      feature_type: ALL_PLANS,
    },
    {
      id: "assignment",
      title: "AI Assistant",
      path: "/user/assignment",
      icon: LuBrain,
      feature_type: AI_ONLY,
      children: [
        {
          id: "LessonPlan",
          title: "Lesson Plan",
          path: "/user/lessonplanlist",
          icon: MdMenuBook,
          feature_type: AI_ONLY,
        },
        {
          id: "assessment",
          title: "Assessment",
          path: "/user/assessmentList",
          icon: FaClipboardList,
          feature_type: AI_ONLY,
        },
      ],
    },
  ],

  student: [
    {
      id: "dashboard",
      title: "Dashboard",
      path: "/user/students",
      icon: BsFillGridFill,
      feature_type: ALL_PLANS,
      children: [
        {
          id: "campusHub",
          title: "Campus Hub ",
          path: "/user/dashboard",
          icon: MdDashboard,
          feature_type: ALL_PLANS,
        },
        {
          id: "aiDashboard",
          title: "AI Analytics",
          path: "/user/ai-dashboard",
          icon: FaChartBar,
          feature_type: AI_ONLY,
        },

        {
          id: "attendance",
          title: "Attendance",
          path: "/user/attendance",
          icon: FaClipboardList,
          feature_type: ALL_PLANS,
        },
      ],
    },
    {
      id: "messaging",
      title: "Messaging",
      icon: MdMessage,
      feature_type: ALL_PLANS,
      children: [
        {
          id: "manage-messages",
          title: "Manage Messages",
          path: "/user/messaging/email",
          icon: MdMessage,
          feature_type: ALL_PLANS,
        },
      ],
    },
    {
      id: "events",
      title: "Event",
      icon: MdEvent,
      feature_type: ALL_PLANS,
      children: [
        {
          id: "event-calendar",
          title: "Event Calendar",
          path: "/user/events",
          icon: MdEvent,
          feature_type: ALL_PLANS,
        },
      ],
    },
    {
      id: "timetable",
      title: "Time Table",
      path: "/user/my-classes/schedule",
      icon: FaTable,
      feature_type: ALL_PLANS,
    },
    {
      id: "exam",
      title: "Exam",
      icon: FaFileAlt,
      feature_type: ALL_PLANS,
      children: [
        {
          id: "exam-timetable",
          title: "Exam Time Table",
          path: "/user/examTimeTable",
          icon: FaTable,
          feature_type: ALL_PLANS,
        },
        {
          id: "exam-result",
          title: "Exam Result",
          path: "/user/exams/results",
          icon: FaFileAlt,
          feature_type: ALL_PLANS,
        },
      ],
    },
    {
      id: "holiday",
      title: "Holiday",
      path: "/user/holidayList",
      icon: FaCalendarAlt,
      feature_type: ALL_PLANS,
    },
    {
      id: "studyHub",
      title: "Study Hub",
      icon: FaGraduationCap,
      feature_type: AI_ONLY,
      children: [
        {
          id: "assessment",
          title: "Assesment",
          path: "/user/assessment",
          feature_type: AI_ONLY,
        },
      ],
    },
  ],

  parent: [
    {
      id: "dashboard",
      title: "Dashboard",
      path: "/user/students",
      icon: BsFillGridFill,
      feature_type: ALL_PLANS,
      children: [
        {
          id: "campusHub",
          title: "Campus Hub ",
          path: "/user/dashboard",
          icon: MdDashboard,
          feature_type: ALL_PLANS,
        },
        {
          id: "aiDashboard",
          title: "AI Analytics",
          path: "/user/ai-dashboard",
          icon: FaChartBar,
          feature_type: AI_ONLY,
        },
        {
          id: "attendance",
          title: "Attendance",
          path: "/user/attendance",
          icon: FaClipboardList,
          feature_type: ALL_PLANS,
        },
      ],
    },
    {
      id: "leave",
      title: "Leave",
      path: "/user/leave",
      icon: FaCalendarAlt,
      feature_type: ALL_PLANS,
    },
    {
      id: "messaging",
      title: "Messaging",
      icon: MdMessage,
      feature_type: ALL_PLANS,
      children: [
        {
          id: "manage-messages",
          title: "Manage Messages",
          path: "/user/messaging/email",
          icon: MdMessage,
          feature_type: ALL_PLANS,
        },
      ],
    },
    {
      id: "events",
      title: "Event",
      icon: MdEvent,
      feature_type: ALL_PLANS,
      children: [
        {
          id: "event-calendar",
          title: "Event Calendar",
          path: "/user/events",
          icon: MdEvent,
          feature_type: ALL_PLANS,
        },
      ],
    },
    {
      id: "holiday",
      title: "Holiday",
      path: "/user/holidayList",
      icon: FaCalendarAlt,
      feature_type: ALL_PLANS,
    },
    {
      id: "exam",
      title: "Exam",
      icon: FaFileAlt,
      feature_type: ALL_PLANS,
      children: [
        {
          id: "exam-timetable",
          title: "Exam Time Table",
          path: "/user/examTimeTable",
          icon: FaTable,
          feature_type: ALL_PLANS,
        },
        {
          id: "exam-result",
          title: "Exam Result",
          path: "/user/exams/results",
          icon: FaFileAlt,
          feature_type: ALL_PLANS,
        },
      ],
    },
    {
      id: "fees",
      title: "Fees",
      path: "",
      icon: PaymentsIcon,
      feature_type: ALL_PLANS,
      addon: true,
      children: [
        {
          id: "payFees",
          title: "Pay Fees",
          path: "/user/payfeesList",
          feature_type: ALL_PLANS,
        },
      ],
    },
  ],
};

// Role ID to menu key mapping
export const roleMap = {
  2: "group_cockpit",
  3: "staff",
  4: "student",
  5: "school_cockpit",
  6: "parent",
};

// Role ID to display name mapping
export const roleDisplayNames = {
  2: "Group Cockpit",
  3: "Staff",
  4: "Student",
  5: "School Cockpit",
  6: "Parent",
};

// Get menu items based on role ID
export const getMenuByRoleId = (roleId) => {
  const roleKey = roleMap[roleId];
  return roleKey ? menuConfig[roleKey] : [];
};

// Get the role menu filtered by the user's plan and add-ons
export const getAccessibleMenu = (roleId, user) =>
  filterMenuItems(getMenuByRoleId(roleId), user);

// Get role display name by ID
export const getRoleDisplayName = (roleId) => {
  return roleDisplayNames[roleId] || "User";
};
